


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AppForestGameTimer extends Vue {

  @Prop({default: '0000-00-00 00:00:00'})
  public deadline!: string;

  @Prop({default: ''})
  public label!: string;

  @Emit('timeout')
  public emitTimeout(): void {
  }

  public time: number = this.deltaTime();
  private intervalHandler: number = 0;

  public created(): void {
    this.initTimer();
  }

  public beforeDestroy(): void {
    this.stop();
  }

  public formattedDeadline(): string {
    const deadline = this.deadlineDate();
    const date = deadline.getDate();
    const month = deadline.getMonth() + 1;
    const formattedDate = date < 10 ? `0${date}` : date;
    const formattedMonth = month < 10 ? `0${month}` : month;
    return `${formattedDate}.${formattedMonth}.${deadline.getFullYear()}`;
  }

  private stop(): void {
    if (this.intervalHandler && this.intervalHandler > 0) {
      clearInterval(this.intervalHandler);
    }
  }

  private initTimer(): void {
    if (this.deadline !== '0000-00-00 00:00:00' && this.daysDifference() <= 1) {
      this.startCountdown();
    }
  }

  private startCountdown(): void {
    this.intervalHandler = setInterval(() => {
      const deltaTime = this.deltaTime();
      if (deltaTime < 0) {
        this.stop();
        this.emitTimeout();
      } else {
        this.time = deltaTime;
      }
    }, 1000);
  }

  private deltaTime(): number {
    const countDownDate = this.deadlineDate().getTime();
    let now = new Date().getTime();
    return countDownDate - now;
  }

  private daysDifference(): number {
    const diff = this.deadlineDate().getTime() - new Date().getTime();
    return Math.round(diff / (1000 * 60 * 60 * 24))
  }

  private deadlineDate(): Date {
    return new Date(this.deadline.replace(' ', 'T'));
  }
}
